import React from 'react';
import { useDispatch } from 'react-redux';
import FuseSplashScreen from '@fuse/core/FuseSplashScreen';

import { showMessage } from 'app/store/fuse/messageSlice';
import jwtService from 'app/auth/services/jwtService';
import { logoutUser, setUser } from 'app/store/userSlice';

const AuthContext = React.createContext<any>({});

export function AuthProvider({ children }) {
	const dispatch = useDispatch<any>();

	const [isAuthenticated, setIsAuthenticated] = React.useState(false);
	const [waitAuthCheck, setWaitAuthCheck] = React.useState(true);

	React.useEffect(() => {
		jwtService.on('onAutoLogin', () => {
			/**
			 * Sign in and retrieve user data with stored token
			 */
			jwtService
				.signInWithToken()
				.then(user => {
					success(user);
				})
				.catch(error => {
					pass(error.message);
				});
		});

		jwtService.on('onLogin', user => {
			// success(user, 'Signed in');
			success(user);
		});

		jwtService.on('onLoginError', message => {
			pass(message, 'error');
		});

		jwtService.on('onLogout', () => {
			pass('Logged out');

			dispatch(logoutUser());
		});

		jwtService.on('onAutoLogout', message => {
			pass(message);

			dispatch(logoutUser());
		});

		// jwtService.on('onNoAccessToken', () => {
		// 	pass();
		// });

		jwtService.init();

		function success(user: any, message?: string) {
			if (message) {
				dispatch(showMessage({ message }));
			}

			Promise.all([
				dispatch(setUser(user))
				// You can receive data in here before app initialization
			]).then(values => {
				setWaitAuthCheck(false);
				setIsAuthenticated(true);
			});
		}

		function pass(message: string, variant?: string) {
			if (message) {
				dispatch(showMessage({ message, variant }));
			}

			setWaitAuthCheck(false);
			setIsAuthenticated(false);
		}
	}, [dispatch]);

	return waitAuthCheck ? (
		<FuseSplashScreen />
	) : (
		<AuthContext.Provider value={{ isAuthenticated }}>{children}</AuthContext.Provider>
	);
}

export function useAuth() {
	const context = React.useContext(AuthContext);
	if (context === undefined) {
		throw new Error('useAuth must be used within a AuthProvider');
	}
	return context;
}

export default { AuthProvider, useAuth };
